import { Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import CopyTextWrapper from 'components/others/CopyTextWrapper';
import type { TemplateKeyRow } from '../keysUtils';

interface KeysTableProps {
    rows: TemplateKeyRow[];
    onKeySelect?: (key: string) => void;
}

const KeysTable = ({ rows, onKeySelect }: KeysTableProps) => {
    const { t } = useTranslation('TemplateValueKeys');

    return (
        <Table size="sm" className="table-hover mb-0">
            <thead>
                <tr className="bg-light">
                    <td>{t('directory.columns.key')}</td>
                    <td>{t('directory.columns.value')}</td>
                </tr>
            </thead>
            <tbody>
                {(rows || []).map((row) => {
                    const badge = (
                        <span
                            className="badge bg-light-secondary text-secondary font-monospace cursor-pointer"
                            onClick={onKeySelect ? () => onKeySelect(row.key) : undefined}
                            role={onKeySelect ? 'button' : undefined}
                        >
                            {row.key}
                        </span>
                    );

                    return (
                        <tr key={row.key}>
                            <td className="fw-medium">
                                {onKeySelect ? (
                                    badge
                                ) : (
                                    <CopyTextWrapper value={row.key}>{badge}</CopyTextWrapper>
                                )}
                            </td>
                            <td>{row.value || ''}</td>
                        </tr>
                    );
                })}
            </tbody>
        </Table>
    );
};

export default KeysTable;
